/**
 * CPF e CNPJ na tela — 16/10/2026 (PRD §51).
 *
 * ⚠️ **Conforto, não garantia.** Quem recusa o documento que não confere é o
 * servidor (`api/src/lib/documento.ts`); aqui a conta existe só para o aviso
 * aparecer junto do campo, na hora, em vez de esperar o "Lançar". A mesma
 * divisão da caixa alta: a tela sobe por conforto, o servidor garante.
 */

export const soDigitos = (t: string): string => t.replace(/\D/g, '');

export function cpfValido(entrada: string): boolean {
  const d = soDigitos(entrada);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const digito = (ate: number): number => {
    let soma = 0;
    for (let i = 0; i < ate; i += 1) soma += Number(d[i]) * (ate + 1 - i);
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };
  return digito(9) === Number(d[9]) && digito(10) === Number(d[10]);
}

export function cnpjValido(entrada: string): boolean {
  const d = soDigitos(entrada);
  if (d.length !== 14 || /^(\d)\1{13}$/.test(d)) return false;
  const digito = (pesos: number[]): number => {
    const soma = pesos.reduce((a, peso, i) => a + Number(d[i]) * peso, 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };
  return (
    digito([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(d[12]) &&
    digito([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(d[13])
  );
}

/** Vazio confere (o documento é opcional); o resto precisa de 11 ou 14 dígitos que passem na conta. */
export function documentoConfere(entrada: string): boolean {
  const d = soDigitos(entrada);
  if (!d) return true;
  return d.length === 11 ? cpfValido(d) : d.length === 14 ? cnpjValido(d) : false;
}

/** Guardado só com dígitos, mostrado formatado (`CLAUDE.md`). */
export function documentoNaTela(entrada: string): string {
  const d = soDigitos(entrada);
  if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  return entrada;
}
